import React from 'react';
import { Icon } from './Icon.js';
export const IconGridLayoutRows3Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("rect", { x: "2", y: "7", width: "14", height: "4", rx: "1.75", ry: "1.75", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("rect", { x: "2", y: "1.5", width: "14", height: "4", rx: "1.75", ry: "1.75", fill: "currentColor" }),
        React.createElement("rect", { x: "2", y: "12.5", width: "14", height: "4", rx: "1.75", ry: "1.75", fill: "currentColor" })));
};
//# sourceMappingURL=IconGridLayoutRows3Fill18.js.map